import {
  Component,
  OnInit,
  ReflectiveInjector,
  Injector,
  ViewChild,
  OnDestroy
} from "@angular/core";

import { ActivatedRoute } from "@angular/router";
import { ToastsManager } from "ng2-toastr/ng2-toastr";

import { ToolbarEvent } from "../../core/events/toolbar.event";
import { BaseService } from "../service/Base.Service";
import { DataTransferObject } from "../entities/DataTransferObject";
import { AppConstants } from "../../app.constant";
import { LocalStorage } from "../helper/localStorage";

import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from "@angular/forms";

import { BaseComponent } from "./Base.Component";
import { Subject } from "rxjs/Subject";
import { Broadcast } from "../events/broadcast";
import { MessageBoxComponent } from "../../components/messagebox/messagebox.component";
import { MessageBoxSettings } from "../../components/messagebox/messagebox.config";
// import { ErrorComponent } from "../../components/error/error.component";
// import { ErrorConfig, errorArgs } from "../../components/error/error.config";
import { Subscription } from "rxjs";
import { errorArgs, ErrorConfig } from "../../components/error/error.config";
import { ErrorComponent } from "../../components/error/error.component";

export abstract class ContainerComponent extends BaseComponent
  implements OnDestroy {
  ngOnDestroy(): void {
    if (this.errorSubscription) this.errorSubscription.unsubscribe();
    if (this.showMessageSubscription) this.showMessageSubscription.unsubscribe();
  }
  protected myForm: FormGroup;

  public title: string;
  public showTb: Boolean;
  public showAdd: Boolean;
  public sList: Boolean;
  public showDelete: Boolean;
  public menu: string;
  public submenu: string;
  public titleIcon: string;

  public cList: any;
  //private isModalOpen: boolean = false;
  private errorSubscription: Subscription;
  private showMessageSubscription:Subscription;

  @ViewChild("ixsmessagebox")
  public messageBox: MessageBoxComponent;

  @ViewChild("error") public errorForm: ErrorComponent;

  constructor() {
    super();
    this.menu = "";
    this.submenu = "";

    this.broadcast.observable<FormGroup>("formgroup").subscribe(x => {
      this.myForm = x.value;
    });

    this.broadcast.observable<string>("title").subscribe(x => {
      this.title = x.value;
    });

    this.showMessageSubscription =  this.broadcast
      .observable<MessageBoxSettings>("showMessage")
      .subscribe(x => {
        this.messageBox.open(x.value);
      });

    this.broadcast.observable<Boolean>("showToolbar").subscribe(x => {
      this.showTb = x.value;
    });

    this.broadcast.observable<Boolean>("hideadd").subscribe(x => {
      this.showAdd = x.value;
    });

    this.broadcast.observable<Boolean>("hidedelete").subscribe(x => {
      this.showDelete = x.value;
    });

    this.broadcast.observable<string>("menu").subscribe(x => {
      this.menu = x.value;
    });
    this.broadcast.observable<string>("submenu").subscribe(x => {
      this.submenu = x.value;
    });
    this.broadcast.observable<string>("titleIcon").subscribe(x => {
      this.titleIcon = x.value;
    });
    this.broadcast.observable<Boolean>("showButtonList").subscribe(x => {
      this.sList = x.value;
    });
    this.broadcast.observable<any>("customList").subscribe(x => {
      this.cList = x.value;
    });
    this.errorSubscription = this.broadcast
      .observable<ErrorConfig>("showError")
      .subscribe(x => {
        
      //  if (!this.isModalOpen) {
          this.errorForm.Id = this.title;
          this.errorForm.showErrors(
            x.value.messages,
            x.value.title,
            x.value.type,
            x.value.displaymode
          );
        //   this.isModalOpen = true;
        // }
      });
  }

  async confirm(event: errorArgs) {
    //this.isModalOpen = false;
    await this.broadcast.publish<errorArgs>("confirmdialog", event);
  }

  async ngOnInit() {}
}



// WEBPACK FOOTER //
// ./src/app/core/component/Container.Component.ts